
import Vue from 'vue';
import { Modal } from 'ant-design-vue';
import { clearAuthToken, getAuthToken } from '@/utils/authToken';
import { getMemberMyInfo } from '../api';
import {
  CQCC_USER_INFO_CHANGE_EVENT,
  CqccUserInfo,
  clearCqccUserInfo,
  getStoredCqccUserInfo,
  normalizeCqccUserInfo,
  saveCqccUserInfo,
} from '../userInfo';

const baseUrl = 'cqcc';

interface NavItem {
  title: string;
  path?: string;
  match?: string[];
}

export default Vue.extend({
  name: 'Header',
  data() {
    return {
      userInfo: null as CqccUserInfo | null,
      userMenuOpen: false,
      navList: [
        {
          title: '首页',
          path: `/${baseUrl}/home`,
          match: [`/${baseUrl}/home`],
        },
        {
          title: '大赛信息',
          path: `/${baseUrl}/rule`,
          match: [`/${baseUrl}/rule`],
        },
        {
          title: '相关新闻',
          path: `/${baseUrl}/news`,
          match: [`/${baseUrl}/news`],
        },
        {
          title: '投稿入口',
          path: `/${baseUrl}/signup`,
          match: [
            `/${baseUrl}/signup`,
            `/${baseUrl}/signup/photo`,
            `/${baseUrl}/signup/video`,
            `/${baseUrl}/signup/audio`,
            `/${baseUrl}/signup/report`,
            `/${baseUrl}/signup/ai`,
          ],
        },
        {
          title: '我的作品',
          path: `/${baseUrl}/works`,
          match: [`/${baseUrl}/works`, `/${baseUrl}/detail`],
        },
      ] as NavItem[],
    };
  },
  computed: {},
  mounted() {
    this.loadUserInfo();
    window.addEventListener(
      CQCC_USER_INFO_CHANGE_EVENT,
      this.onUserInfoChange as EventListener,
    );
    document.addEventListener('click', this.onDocumentClick as EventListener);
  },
  beforeDestroy() {
    window.removeEventListener(
      CQCC_USER_INFO_CHANGE_EVENT,
      this.onUserInfoChange as EventListener,
    );
    document.removeEventListener(
      'click',
      this.onDocumentClick as EventListener,
    );
  },
  methods: {
    onUserInfoChange(event: Event) {
      const customEvent = event as CustomEvent<CqccUserInfo>;
      this.userInfo = customEvent.detail || getStoredCqccUserInfo();
      if (!this.userInfo) {
        this.userMenuOpen = false;
      }
    },
    onDocumentClick() {
      this.userMenuOpen = false;
    },
    async loadUserInfo() {
      const storedUserInfo = getStoredCqccUserInfo();
      if (storedUserInfo) {
        this.userInfo = storedUserInfo;
      }

      if (!getAuthToken()) {
        this.userInfo = null;
        return;
      }

      try {
        const res = await getMemberMyInfo();
        const userInfo = normalizeCqccUserInfo(res);
        this.userInfo = userInfo;
        saveCqccUserInfo(userInfo);
      } catch (err) {
        if (!storedUserInfo) {
          this.userInfo = null;
        }
      }
    },
    isActive(item: NavItem) {
      return !!item.match && item.match.indexOf(this.$route.path) > -1;
    },
    goNav(item: NavItem) {
      if (!item.path || item.path === this.$route.path) {
        return;
      }
      this.$router.push(item.path).catch((err: Error) => err);
    },
    goLogin() {
      const path = `/${baseUrl}/login`;
      if (this.$route.path !== path) {
        this.$router.push(path).catch((err: Error) => err);
      }
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    goWorks() {
      this.userMenuOpen = false;
      const path = `/${baseUrl}/works`;
      if (this.$route.path !== path) {
        this.$router.push(path).catch((err: Error) => err);
      }
    },
    confirmLogout() {
      this.userMenuOpen = false;
      Modal.confirm({
        title: '是否退出登录？',
        okText: '是',
        cancelText: '否',
        onOk: () => {
          clearAuthToken();
          clearCqccUserInfo();
          window.location.reload();
        },
      });
    },
  },
});
